import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class sAElectronicTicketAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SAElectronicTickets';

  /**
   * Lấy ra danh sách vé điện tử có thể lập chứng từ
   * @param {*} payload
   * @returns
   * * NNLINH 12.09.2023
   */
  async getDataElectronicTicket(payload) {
      let apiUrl = this.getAPIUrl();

      let request = {
      url: apiUrl + '/DataElectronicTicket',
      data: payload,
      };

      return await httpClient.postAsync(request);
  }
  /**
 * Lấy ra dữ liệu sinh chứng từ từ vé điện tử.
 * @param {*} payload
 * @returns
 * * NNLINH 07.09.2023
 */
  async getDataGenerateTicket(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DataGenerateTicket',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new sAElectronicTicketAPI();
